import Deferred from '@lts-web/utils/Deferred';

class DeferredList {
    #list = null;

    constructor(list) {
        this.#list = list || [];
    }

    static resolve (deferredList, deferredId, data) {
        const deferred = DeferredList.get(deferredList, deferredId);
        Deferred.resolve(deferred, data);
        return deferred;
    }

    static then (deferredList, deferredId, callback) {
        const deferred = DeferredList.get(deferredList, deferredId);
        deferred.then((...args) => {
            callback(deferred, ...args);
        });
        return deferred;
    }

    static add (deferredList, id, deferred) {
        if (!(deferred instanceof Deferred))
            throw new TypeError('First argument must be and instanceof `Deferred`');

        deferredList.getList().push({ id, deferred });
    }

    static get (deferredList, deferredId) {
        return deferredList.getList().find(({ id }) => id === deferredId).deferred;
    }

    getList () {
        return this.#list;
    }
}

export default DeferredList;